__turbopack_context__.v({
  "em-sig-clickable-action-icon": "EmailSignatureSpanButton-module-scss-module__CaxT5G__em-sig-clickable-action-icon",
});
